import { Injectable } from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {ApiService} from '../../../../core/service/api.service';

@Injectable()
export class RedirectLogService {

    constructor(private api: ApiService) { }

    findRedirectLogs(criteria?: Object): Observable<any> {
        return this.api.get('vna/redirect-log', criteria);
    }

    findRedirectLog(pk: number): Observable<any> {
        return this.api.get('vna/redirect-log/' + pk);
    }
}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/vna-campaign/services/redirect-log.service.ts